export default {
  ADD_JOB(state, job) {
    state.jobs.push(job)
  },
  UPDATE_JOB(state, { id, patch }) {
    const job = state.jobs.find((j) => j.id === id)
    if (job) Object.assign(job, patch)
  },
  MARK_JOB_APPLIED(state, id) {
    const job = state.jobs.find((j) => j.id === id)
    if (job) job.appliedLocally = true
  },
  REMOVE_JOB(state, id) {
    const idx = state.jobs.findIndex((j) => j.id === id)
    if (idx !== -1) state.jobs.splice(idx, 1)
  },
}
